import React from 'react';

import Layout from '../components/layout';
import Head from '../components/head';
import contactStyles from './contact.module.scss';

const ContactPage = () => {
  return (
    <div>
      <Layout>
        <Head title="Contact" />
      <h1>Contact</h1>
      <p>
        If you are looking for a developer for some freelance work please feel free to reach out to
        me. My contact information can be found below. Also I offer one on one training for web 
        development as well as Python development. 
      </p>
      <ul>
        <li className={contactStyles.link}><a target="blank" href="https://www.linkedin.com/in/jonathan-reeves/">LinkedIn</a></li>
        <li className={contactStyles.link}><a target="blank" href="https://github.com/RedHoodJT1988">GitHub</a></li>
        <h2>Or fill out the form below to send me a direct email</h2>
        <form className={contactStyles.form} method="post" netlify-honeypot="bot-field" data-netlify="true" name="contact">
          <input type="hidden" name="bot-field" />
          <input type="hidden" name="form-name" value="contact" />
          <label className={contactStyles.name}>
            Name 
            <input type="text" name="name" id="name" />
          </label>
          <label className={contactStyles.email}>
            Email 
            <input type="email" name="email" id="email" />
          </label>
          <label className={contactStyles.subject}>
            Subject
            <input type="text" name="subject" id="subject" />
          </label>
          <label className={contactStyles.message}>
            Message
            <textarea name="message" id="message" rows="5" />
            </label>
            <button className={contactStyles.button} type="submit">Send</button>
          

        </form>
      </ul>
      </Layout>
    </div>
  )
}

export default ContactPage;